import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Wklej tutaj dane konfiguracyjne Firebase, które skopiowałeś z Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyAdsVvH0VVpfqwvoQMDCyljwZ_Mbkk9FNw",
  authDomain: "ai-journaling-fil.firebaseapp.com",
  projectId: "ai-journaling-fil",
  storageBucket: "ai-journaling-fil.firebasestorage.app",
  messagingSenderId: "253968588481",
  appId: "1:253968588481:web:6a6966819d954167a97e40"
};

// Inicjalizacja Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
